import { jsx as _jsx } from "react/jsx-runtime";
// icon:bx-minus | Boxicons https://boxicons.com/ | Atisa
import { chakra } from '@chakra-ui/react';
export const BxMinus = chakra((props) => {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "currentColor", height: "1em", width: "1em", ...props, children: _jsx("path", { d: "M5 11h14v2H5z" }) }));
});
